export const customsMock = [
    {
        country: "Турция",
        status: "active",
        note: "Выпущена в 2017"
    },
    {
        country: "Неизвестно",
        status: "inactive",
        note: ""
    },
    {
        country: "Республика Беларусь",
        status: "active",
        note: "Уехала 29 декабря 2021"
    },
    {
        country: "Россия",
        status: "active",
        note: "Приехала 29 декабря 2021"
    }
];